import * as React from 'react';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
// import CircularProgress from "@mui/material/CircularProgress";
import { useStore } from 'react-redux';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import Select, { SelectChangeEvent } from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import Chip from '@mui/material/Chip';
import OutlinedInput from '@mui/material/OutlinedInput'; // Import OutlinedInput

export default function Status({ onChange, defaultValue, multiple, size, options }: any) {
  const statusOptions = options || [];

  if (multiple) {
    return (
      <FormControl variant="outlined" fullWidth>
        <InputLabel size={size} id="demo-multiple-chip-label">
          Status
        </InputLabel>
        <Select
          labelId="demo-multiple-chip-label"
          size={size}
          id="demo-multiple-chip"
          multiple
          defaultValue={defaultValue ?? []}
          onChange={(event: SelectChangeEvent) => {
            onChange(event.target.value);
          }}
          // Use OutlinedInput for the outlined variant and pass the label
          input={<OutlinedInput size={size} id="select-multiple-chip" label="Status" />}
          renderValue={(selected) => {
            // Find the label corresponding to the value
            const selectedArray = Array.isArray(selected) ? selected : [];
            const selectedLabels = selectedArray.map((value: string) => {
              const option = statusOptions.find((opt: { value: string; label: string }) => opt.value === value);
              return option ? option.label : value; // Fallback to value if label not found
            });
            return selectedLabels.map((label) => <Chip key={label} label={label} size={size} />);
          }}
        >
          {statusOptions.map((v: any, index: number) => (
            <MenuItem key={`${v.label}-${index}-Select-item`} value={v.value}>
              {v.label}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    );
  }

  return (
    <Autocomplete
      defaultValue={defaultValue ?? ''}
      isOptionEqualToValue={(option, value) => option.label === value.label}
      getOptionLabel={(option: any) => option.label}
      options={statusOptions}
      onChange={(e, newValue) => {
        onChange(newValue);
      }}
      renderInput={(params) => (
        <TextField
          {...params}
          variant="outlined"
          fullWidth
          label="Status"
          InputProps={{
            ...params.InputProps,
            endAdornment: <React.Fragment>{params.InputProps.endAdornment}</React.Fragment>,
          }}
        />
      )}
    />
  );
}
